import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
    selector: 'app-dialog-spinner',
    templateUrl: './dialog-spinner.component.html',
    styleUrls: ['./dialog-spinner.component.scss'],
    standalone: false
})
export class DialogSpinnerComponent implements OnInit {
	message;

	constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
		this.message = data.message || null;
	}

	ngOnInit() {}
}
